<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/cms/content-library'">Content Library</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      <span class="fs-5 fw-bold mb-0">Edit Asset</span>
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3 mb-3">
          <div class="col">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>
          <div class="col">
            <label class="form-label">Type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
              <select class="form-select" formControlName="type">
                <option value="" disabled>Select type</option>
                @for (type of assetTypes; track type) {
                  <option [value]="type.identifier">{{ type.label }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label class="form-label">Product</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select class="form-select" formControlName="productId">
                <option [ngValue]="null" disabled>Select product</option>
                @for (product of products; track product.id) {
                  <option [ngValue]="product.id">{{ product.name }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label class="form-label">Language</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-translate"></i></span>
              <select class="form-select" formControlName="lang">
                <option [ngValue]="null">All languages</option>
                @for (language of languages; track language.isoCode) {
                  <option [ngValue]="language.isoCode">{{ language.name }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        @if (isTextAsset()) {
          <div class="mb-3">
            <label class="form-label">Content</label>
            <div class="code-editor">
              <code-editor [(ngModel)]="editorContent" [ngModelOptions]="{standalone: true}" [extensions]="editorExtensions"/>
            </div>
          </div>
        }
        @if (!isTextAsset()) {
          <div class="mb-3">
            <label class="form-label">Document</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-file-earmark-arrow-up"></i></span>
              <input type="file" class="form-control" (change)="upload($event)">
            </div>
            @if (asset?.document) {
              <div class="form-text">
                Current: {{ asset?.document?.filename }}
              </div>
            }
            @if (uploadFile) {
              <div class="form-text text-success">
                <i class="bi bi-check-circle me-1"></i>{{ uploadFile.filename }}
              </div>
            }
          </div>
        }
        @if (isImageAsset() && asset?.document) {
          <div class="mb-3">
            <label class="form-label">Preview</label>
            <div class="border rounded p-3 bg-light text-center">
              <img [src]="imageService.getImageUrl($safeNavigationMigration(asset?.document), 400, null, false)" alt="Preview" class="img-fluid">
            </div>
          </div>
        }
        @if (isVideoAsset() && asset?.document?.url) {
          <div class="mb-3">
            <label class="form-label">Preview</label>
            <div class="border rounded p-3 bg-light text-center">
              <video [src]="asset!.document!.url!" controls class="img-fluid" style="max-height: 400px;"></video>
            </div>
          </div>
        }
        <div class="row mt-4">
          <div class="col text-end">
            <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
              <span>Update</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
